import styles from '@components/components/CmsComponents/components/CmsCallToAction/CmsCallToAction.module.scss';
import { trackInteraction } from '@components/hooks';
import React from 'react';
import { Button, FontAwesomeProIcon, Link } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const CmsCallToAction = ({ className, items }) => (
  <div className={styles.container}>
    {items.map(
      ({
        icon,
        link,
        theme,
        onClick,
        chatBot,
        className: itemClassName,
        interactionId,
        ...props
      }) => {
        const callBack = onClick || (() => trackInteraction(interactionId));
        return (
          <Button
            className={classNames(
              styles.button,
              styles[theme],
              className,
              itemClassName,
            )}
            isElevated
            key={link?.title}
            onClick={() => {
              callBack();
            }}
            render={<Link to={link?.url} />}
            shape="squared"
            {...props}
          >
            <FontAwesomeProIcon
              className={styles.icon}
              icon={icon}
              role="presentation"
              type="regular"
            />
            {/* eslint-disable-next-line react/no-danger */}
            <span dangerouslySetInnerHTML={{ __html: link?.title }} />
          </Button>
        );
      },
    )}
  </div>
);

CmsCallToAction.propTypes = {
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default CmsCallToAction;
